// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","525":"component---src-pages-plasmic-host-tsx","774":"framework","815":"component---src-templates-default-plasmic-page-tsx"}[chunkId] + "-" + {"351":"84d16239d3843bbaef8d","525":"fb45f359357dc68e13c2","774":"f9d2f394572f8a395c93","815":"4ef1ab97f14f5251a9cc"}[chunkId] + ".js";
};